// import React from 'react';
// import {
//     Box, Button, Container, TextField, Typography, Grid,
//     MenuItem, Select, FormControl, InputLabel, RadioGroup, FormControlLabel, Radio,
//     IconButton, Popover
// } from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { Link } from 'react-router';
// import { styleOptions, regionOptions } from '../data/TravelOptions.js';
// import './RegisterForm.css';
// import { useNavigate } from 'react-router';
// import { LocalizationProvider, DateCalendar, PickersDay } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import dayjs from 'dayjs';
// import 'dayjs/locale/he';
//
// const theme = createTheme({
//     direction: 'rtl',
//     typography: {
//         fontFamily: 'Varela Round, sans-serif',
//         htmlSelect: {
//             direction: 'rtl',
//         },
//     },
// });
//
// export default function RegisterForm({ setIsLoggedIn }) {
//     const navigate = useNavigate();
//     const [tripRegion, setTripRegion] = React.useState([]);
//     const [tripStyle, setTripStyle] = React.useState([]);
//     const [studentImage, setStudentImage] = React.useState(null);
//     const [birthDate, setBirthDate] = React.useState(null);
//     const [anchorEl, setAnchorEl] = React.useState(null);
//     const [gender, setGender] = React.useState('');
//
//     const openPopover = Boolean(anchorEl);
//
//     const rtlProps = {
//         inputProps: { dir: 'rtl' },
//         InputProps: { sx: { textAlign: 'right' } },
//     };
//
//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const data = new FormData(e.currentTarget);
//         const userData = {
//             fullName: data.get('fullName'),
//             email: data.get('email'),
//             phone: data.get('phone'),
//             password: data.get('password'),
//             gender,
//             birthDate: birthDate ? birthDate.format('YYYY-MM-DD') : '',
//             location: data.get('location'),
//             interests: data.get('interests'),
//             tripRegion: tripRegion.join(','),
//             tripStyle: tripStyle.join(','),
//             aboutMe: data.get('aboutMe'),
//             studentImage,
//         };
//         console.log(userData);
//
//         setIsLoggedIn(true);
//         navigate('/');
//     };
//
//     const handleFileChange = (e) => {
//         setStudentImage(e.target.files[0]);
//     };
//
//     return (
//         <ThemeProvider theme={theme}>
//             <Box className="register-page-background">
//                 <Container maxWidth="sm" dir="rtl">
//                     <Box className="register-form-container">
//                         <Typography variant="h5" className="register-title">
//                             צור חשבון
//                         </Typography>
//                         <Box component="form" onSubmit={handleSubmit} noValidate>
//                             <TextField required fullWidth margin="normal" name="fullName" label="שם מלא" {...rtlProps} />
//                             <TextField required fullWidth margin="normal" name="email" label="אימייל" type="email" {...rtlProps} />
//                             <TextField required fullWidth margin="normal" name="phone" label="טלפון" type="tel" {...rtlProps} />
//                             <TextField required fullWidth margin="normal" name="password" label="סיסמה" type="password" {...rtlProps} />
//
//                             {/* Gender - Radio buttons (no default) */}
//                             <FormControl component="fieldset" fullWidth margin="normal">
//                                 <Typography variant="subtitle1" sx={{ mb: 1 }}>מגדר</Typography>
//                                 <RadioGroup
//                                     row
//                                     name="gender"
//                                     value={gender}
//                                     onChange={(e) => setGender(e.target.value)}
//                                 >
//                                     <FormControlLabel value="זכר" control={<Radio />} label="זכר" />
//                                     <FormControlLabel value="נקבה" control={<Radio />} label="נקבה" />
//                                     <FormControlLabel value="אחר" control={<Radio />} label="אחר" />
//                                 </RadioGroup>
//                             </FormControl>
//
//                             {/* Date of Birth */}
//                             <FormControl fullWidth margin="normal">
//                                 <TextField
//                                     label="תאריך לידה"
//                                     value={birthDate ? birthDate.format("DD/MM/YYYY") : ''}
//                                     onClick={(e) => setAnchorEl(e.currentTarget)}
//                                     fullWidth
//                                     InputProps={{
//                                         readOnly: true,
//                                         endAdornment: (
//                                             <IconButton onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 setAnchorEl(e.currentTarget);
//                                             }}>
//                                                 <CalendarTodayIcon />
//                                             </IconButton>
//                                         ),
//                                         sx: { direction: 'rtl' },
//                                     }}
//                                 />
//                                 <Popover
//                                     open={openPopover}
//                                     anchorEl={anchorEl}
//                                     onClose={() => setAnchorEl(null)}
//                                     anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//                                     transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//                                 >
//                                     <Box sx={{ p: 1 }}>
//                                         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="he">
//                                             <DateCalendar
//                                                 value={birthDate}
//                                                 onChange={(date) => {
//                                                     setBirthDate(date);
//                                                     setAnchorEl(null);
//                                                 }}
//                                                 slots={{
//                                                     day: (props) => (
//                                                         <PickersDay
//                                                             {...props}
//                                                             sx={{
//                                                                 '&:hover': { bgcolor: '#e7efe3' },
//                                                                 ...(dayjs().isSame(props.day, 'day') && {
//                                                                     border: '1px solid #1B5C1C',
//                                                                     bgcolor: 'transparent',
//                                                                     '&:hover': { bgcolor: '#e7efe3' },
//                                                                 }),
//                                                             }}
//                                                         />
//                                                     ),
//                                                 }}
//                                             />
//                                         </LocalizationProvider>
//                                     </Box>
//                                 </Popover>
//                             </FormControl>
//
//                             <TextField fullWidth margin="normal" name="location" label="מקום מגורים" {...rtlProps} />
//                             <TextField fullWidth margin="normal" name="interests" label="תחומי עניין" {...rtlProps} />
//
//                             {/* Select: אזורי טיול מועדפים */}
//                             <FormControl fullWidth margin="normal">
//                                 <InputLabel>אזורי טיול מועדפים</InputLabel>
//                                 <Select
//                                     value={tripRegion}
//                                     onChange={(e) => setTripRegion(e.target.value)}
//                                     name="tripRegion"
//                                     multiple
//                                     inputProps={{ dir: 'rtl' }}
//                                     MenuProps={{
//                                         anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
//                                         transformOrigin: { vertical: 'top', horizontal: 'right' },
//                                         PaperProps: {
//                                             dir: 'rtl',
//                                             style: { maxHeight: 300 },
//                                         },
//                                     }}
//                                 >
//                                     {regionOptions.map((option) => (
//                                         <MenuItem key={option.value} value={option.value}>
//                                             {option.label}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//
//                             {/* Select: סגנון טיול אהוב */}
//                             <FormControl fullWidth margin="normal">
//                                 <InputLabel>סגנון טיול אהוב</InputLabel>
//                                 <Select
//                                     value={tripStyle}
//                                     onChange={(e) => setTripStyle(e.target.value)}
//                                     name="tripStyle"
//                                     multiple
//                                     inputProps={{ dir: 'rtl' }}
//                                     MenuProps={{
//                                         anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
//                                         transformOrigin: { vertical: 'top', horizontal: 'right' },
//                                         PaperProps: {
//                                             dir: 'rtl',
//                                             style: { maxHeight: 300 },
//                                         },
//                                     }}
//                                 >
//                                     {styleOptions.map((option) => (
//                                         <MenuItem key={option.value} value={option.value}>
//                                             {option.label}
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//
//                             <TextField
//                                 fullWidth
//                                 margin="normal"
//                                 name="aboutMe"
//                                 label="קצת עליי"
//                                 multiline
//                                 rows={3}
//                                 {...rtlProps}
//                             />
//
//                             <Button
//                                 classes={"register-button"}
//                                 variant="outlined"
//                                 component="label"
//                                 fullWidth
//                                 className="upload-button"
//                                 sx={{ mt: 2 }}
//                             >
//                                 העלה כרטיס סטודנט / אישור לימודים *
//                                 <input type="file" accept="image/*" hidden onChange={handleFileChange} />
//                             </Button>
//
//                             <Button type="submit" classes={"register-button"} fullWidth variant="contained" className="register-button" sx={{ mt: 2 }}>
//                                 הירשם
//                             </Button>
//
//                             <Grid container justifyContent="center" className="already-have-account" sx={{ mt: 2 }}>
//                                 <Grid item>
//                                     <Typography variant="body2">
//                                         כבר יש לך חשבון? <Link to="/login">התחבר</Link>
//                                     </Typography>
//                                 </Grid>
//                             </Grid>
//                         </Box>
//                     </Box>
//                 </Container>
//             </Box>
//         </ThemeProvider>
//     );
// }



// גרסה עדכנית

// import React from 'react';
// import {
//     Box, Button, Container, TextField, Typography, Grid,
//     MenuItem, Select, FormControl, InputLabel, RadioGroup, FormControlLabel, Radio,
//     IconButton, Popover
// } from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { Link } from 'react-router';
// import { styleOptions, regionOptions } from '../data/TravelOptions.js';
// import './RegisterForm.css';
// import { useNavigate } from 'react-router';
// import { LocalizationProvider, DateCalendar, PickersDay } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import dayjs from 'dayjs';
// import 'dayjs/locale/he';
//
// // ✅ Google login
// import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
//
// const theme = createTheme({
//     direction: 'rtl',
//     typography: {
//         fontFamily: 'Varela Round, sans-serif',
//     },
// });
//
// export default function RegisterForm({ setIsLoggedIn }) {
//     const navigate = useNavigate();
//     const [tripRegion, setTripRegion] = React.useState([]);
//     const [tripStyle, setTripStyle] = React.useState([]);
//     const [studentImage, setStudentImage] = React.useState(null);
//     const [birthDate, setBirthDate] = React.useState(null);
//     const [anchorEl, setAnchorEl] = React.useState(null);
//     const [gender, setGender] = React.useState('');
//
//     const openPopover = Boolean(anchorEl);
//
//     const rtlProps = {
//         inputProps: { dir: 'rtl' },
//         InputProps: { sx: { textAlign: 'right' } },
//     };
//
//     // ✅ custom google login hook
//     const login = useGoogleLogin({
//         onSuccess: (tokenResponse) => {
//             console.log(tokenResponse);
//             setIsLoggedIn(true);
//             navigate('/extra-details');
//         },
//         onError: () => {
//             console.log("Google Login Failed");
//         }
//     });
//
//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const data = new FormData(e.currentTarget);
//         const userData = {
//             fullName: data.get('fullName'),
//             email: data.get('email'),
//             phone: data.get('phone'),
//             password: data.get('password'),
//             gender,
//             birthDate: birthDate ? birthDate.format('YYYY-MM-DD') : '',
//             location: data.get('location'),
//             interests: data.get('interests'),
//             tripRegion: tripRegion.join(','),
//             tripStyle: tripStyle.join(','),
//             aboutMe: data.get('aboutMe'),
//             studentImage,
//         };
//         console.log(userData);
//
//         setIsLoggedIn(true);
//         navigate('/');
//     };
//
//     const handleFileChange = (e) => {
//         setStudentImage(e.target.files[0]);
//     };
//
//     return (
//         <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
//             <ThemeProvider theme={theme}>
//                 <Box className="register-page-background">
//                     <Container maxWidth="sm" dir="rtl">
//                         <Box className="register-form-container">
//                             <Typography variant="h5" className="register-title">
//                                 צור חשבון
//                             </Typography>
//
//                             {/* ✅ custom Google button */}
//                             <Button
//                                 onClick={login}
//                                 fullWidth
//                                 variant="contained"
//                                 className="google-login-button"
//                             >
//                                 <img src="/images/google-icon.png" alt="Google" />
//                                 כניסה באמצעות Google
//                             </Button>
//
//                             <Typography variant="subtitle2" align="center" sx={{ mt: 2 }}>
//                                 או הירשם עם כתובת אימייל
//                             </Typography>
//
//                             <Box component="form" onSubmit={handleSubmit} noValidate>
//                                 <TextField required fullWidth margin="normal" name="fullName" label="שם מלא" {...rtlProps} />
//                                 <TextField required fullWidth margin="normal" name="email" label="אימייל" type="email" {...rtlProps} />
//                                 <TextField required fullWidth margin="normal" name="phone" label="טלפון" type="tel" {...rtlProps} />
//                                 <TextField required fullWidth margin="normal" name="password" label="סיסמה" type="password" {...rtlProps} />
//
//                                 <FormControl component="fieldset" fullWidth margin="normal">
//                                     <Typography variant="subtitle1" sx={{ mb: 1 }}>מגדר</Typography>
//                                     <RadioGroup
//                                         row
//                                         name="gender"
//                                         value={gender}
//                                         onChange={(e) => setGender(e.target.value)}
//                                     >
//                                         <FormControlLabel value="זכר" control={<Radio />} label="זכר" />
//                                         <FormControlLabel value="נקבה" control={<Radio />} label="נקבה" />
//                                         <FormControlLabel value="אחר" control={<Radio />} label="אחר" />
//                                     </RadioGroup>
//                                 </FormControl>
//
//                                 <FormControl fullWidth margin="normal">
//                                     <TextField
//                                         label="תאריך לידה"
//                                         value={birthDate ? birthDate.format("DD/MM/YYYY") : ''}
//                                         onClick={(e) => setAnchorEl(e.currentTarget)}
//                                         fullWidth
//                                         InputProps={{
//                                             readOnly: true,
//                                             endAdornment: (
//                                                 <IconButton onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     setAnchorEl(e.currentTarget);
//                                                 }}>
//                                                     <CalendarTodayIcon />
//                                                 </IconButton>
//                                             ),
//                                             sx: { direction: 'rtl' },
//                                         }}
//                                     />
//                                     <Popover
//                                         open={openPopover}
//                                         anchorEl={anchorEl}
//                                         onClose={() => setAnchorEl(null)}
//                                         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//                                         transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//                                     >
//                                         <Box sx={{ p: 1 }}>
//                                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="he">
//                                                 <DateCalendar
//                                                     value={birthDate}
//                                                     onChange={(date) => {
//                                                         setBirthDate(date);
//                                                         setAnchorEl(null);
//                                                     }}
//                                                     slots={{
//                                                         day: (props) => (
//                                                             <PickersDay
//                                                                 {...props}
//                                                                 sx={{
//                                                                     '&:hover': { bgcolor: '#e7efe3' },
//                                                                     ...(dayjs().isSame(props.day, 'day') && {
//                                                                         border: '1px solid #1B5C1C',
//                                                                         bgcolor: 'transparent',
//                                                                         '&:hover': { bgcolor: '#e7efe3' },
//                                                                     }),
//                                                                 }}
//                                                             />
//                                                         ),
//                                                     }}
//                                                 />
//                                             </LocalizationProvider>
//                                         </Box>
//                                     </Popover>
//                                 </FormControl>
//
//                                 <TextField fullWidth margin="normal" name="location" label="מקום מגורים" {...rtlProps} />
//                                 <TextField fullWidth margin="normal" name="interests" label="תחומי עניין" {...rtlProps} />
//
//                                 <FormControl fullWidth margin="normal">
//                                     <InputLabel>אזורי טיול מועדפים</InputLabel>
//                                     <Select
//                                         value={tripRegion}
//                                         onChange={(e) => setTripRegion(e.target.value)}
//                                         name="tripRegion"
//                                         multiple
//                                         inputProps={{ dir: 'rtl' }}
//                                         MenuProps={{
//                                             anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
//                                             transformOrigin: { vertical: 'top', horizontal: 'right' },
//                                             PaperProps: {
//                                                 dir: 'rtl',
//                                                 style: { maxHeight: 300 },
//                                             },
//                                         }}
//                                     >
//                                         {regionOptions.map((option) => (
//                                             <MenuItem key={option.value} value={option.value}>
//                                                 {option.label}
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//
//                                 <FormControl fullWidth margin="normal">
//                                     <InputLabel>סגנון טיול אהוב</InputLabel>
//                                     <Select
//                                         value={tripStyle}
//                                         onChange={(e) => setTripStyle(e.target.value)}
//                                         name="tripStyle"
//                                         multiple
//                                         inputProps={{ dir: 'rtl' }}
//                                         MenuProps={{
//                                             anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
//                                             transformOrigin: { vertical: 'top', horizontal: 'right' },
//                                             PaperProps: {
//                                                 dir: 'rtl',
//                                                 style: { maxHeight: 300 },
//                                             },
//                                         }}
//                                     >
//                                         {styleOptions.map((option) => (
//                                             <MenuItem key={option.value} value={option.value}>
//                                                 {option.label}
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//
//                                 <TextField
//                                     fullWidth
//                                     margin="normal"
//                                     name="aboutMe"
//                                     label="קצת עליי"
//                                     multiline
//                                     rows={3}
//                                     {...rtlProps}
//                                 />
//
//                                 <Button
//                                     classes={"register-button"}
//                                     variant="outlined"
//                                     component="label"
//                                     fullWidth
//                                     className="upload-button"
//                                     sx={{ mt: 2 }}
//                                 >
//                                     העלה כרטיס סטודנט / אישור לימודים *
//                                     <input type="file" accept="image/*" hidden onChange={handleFileChange} />
//                                 </Button>
//
//                                 <Button type="submit" classes={"register-button"} fullWidth variant="contained" className="register-button" sx={{ mt: 2 }}>
//                                     הירשם
//                                 </Button>
//
//                                 <Grid container justifyContent="center" className="already-have-account" sx={{ mt: 2 }}>
//                                     <Grid item>
//                                         <Typography variant="body2">
//                                             כבר יש לך חשבון? <Link to="/login">התחבר</Link>
//                                         </Typography>
//                                     </Grid>
//                                 </Grid>
//                             </Box>
//                         </Box>
//                     </Container>
//                 </Box>
//             </ThemeProvider>
//         </GoogleOAuthProvider>
//     );
// }


// ניסיון פיצול מסכים

import React, { useState } from 'react';
import GoogleLoginStep from './GoogleLoginStep';
import RegisterDetailsStep from './RegisterDetailsStep';

export default function RegisterForm() {
    const [userData, setUserData] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false); // ← נוספה

    return (
        <>
            {!userData ? (
                <GoogleLoginStep setUserData={setUserData} />
            ) : (
                <RegisterDetailsStep
                    userData={userData}
                    setIsLoggedIn={setIsLoggedIn} // ← מועבר הלאה
                />
            )}
        </>
    );
}
